import React from 'react';


export const LandingHowItWorks = ({ navigate, t }) => (
      <section id="how-it-works" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-orange-50 to-red-50">
        <div className="mx-auto max-w-7xl">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-white border border-orange-200 rounded-full text-sm font-semibold mb-4">
              🗺️ {t('landing.yourJourney')}
            </div>
            <h2 className="font-heading text-4xl font-bold text-gray-900 mb-4">
              {t('landing.howItWorksTitle')}
            </h2>
            <p className="text-xl text-gray-600">
              {t('landing.howItWorksSubtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative">
            {/* Connection Line */}
            <div className="hidden md:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-orange-300 via-red-300 to-orange-300" style={{ top: '120px' }}></div>

            {[
              {
                step: '1',
                titleKey: 'landing.steps.step1.title',
                descKey: 'landing.steps.step1.desc',
                icon: '📝'
              },
              {
                step: '2',
                titleKey: 'landing.steps.step2.title',
                descKey: 'landing.steps.step2.desc',
                icon: '💬'
              },
              {
                step: '3',
                titleKey: 'landing.steps.step3.title',
                descKey: 'landing.steps.step3.desc',
                icon: '📅'
              },
              {
                step: '4',
                titleKey: 'landing.steps.step4.title',
                descKey: 'landing.steps.step4.desc',
                icon: '✨'
              }
            ].map((step, index) => (
              <div key={index} className="relative z-10">
                <div className="bg-white rounded-2xl p-8 border-2 border-orange-100 shadow-lg">
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center text-white font-bold text-2xl mb-4 mx-auto">
                    {step.step}
                  </div>
                  <div className="text-4xl text-center mb-4">{step.icon}</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                    {t(step.titleKey)}
                  </h3>
                  <p className="text-gray-600 text-center text-sm">
                    {t(step.descKey)}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <button
              onClick={() => navigate('/register')}
              className="px-8 py-4 bg-gradient-to-r from-orange-500 to-red-600 text-white rounded-xl font-semibold text-lg hover:shadow-xl transition-all inline-flex items-center gap-2"
            >
              {t('landing.startJourney')}
              <span>→</span>
            </button>
          </div>
        </div>
      </section>
);
